module.exports = __webpack_public_path__ + "static/img/concierge_product_banner.65ddc8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_barocare_conci/sub1/concierge_product_banner.png
// module id = JbjE
// module chunks = 0